import { render } from "./LoadMoreData.vue?vue&type=template&id=c7a5c54e"
import script from "./LoadMoreData.vue?vue&type=script&lang=js"
export * from "./LoadMoreData.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__